import { useState } from "react";
import Nav from "react-bootstrap/Nav";
import { NavLink, useLocation } from "react-router-dom";
import classes from "./Sidebar.module.css";
import Toolbar1Logo from "../../assets/toolbar/toolbar_icon_1.svg";
import Toolbar2Logo from "../../assets/toolbar/toolbar_icon_2.svg";
import Toolbar3Logo from "../../assets/toolbar/toolbar_icon_3.svg";
import Toolbar4Logo from "../../assets/toolbar/toolbar_icon_4.svg";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { useDispatch } from "react-redux";
import {
  SelectedNode,
  changeSelectedNode,
} from "../../redux/reducers/AssetReducer";
import { changePage } from "../../redux/reducers/UIReducer";
import TestModal from "../Tests/TestModal";
import RadarModal from "../RadarChart/RadarModal";
import RadarChart from "../RadarChart/RadarChart";

const Sidebar = () => {
  const dispatch = useDispatch();
  const [showModal, setShowModal] = useState(false);
  const [showRadar, setShowRadar] = useState(false);
  const { pathname } = useLocation();

  const handleCloseModal = () => setShowModal(false);
  const handleShowModal = () => setShowModal(true);
  const handleShowRadar = () => setShowRadar(true);
  const handleCloseRadar = () => setShowRadar(false);

  const handleOnClick = (page: string) => {
    dispatch(changePage(page));
    switch (page) {
      case "Assets":
        const emptySelectedNode: SelectedNode = {
          id: "",
          name: "",
          level: 0,
          parentId: "",
        };
        dispatch(changeSelectedNode(emptySelectedNode));
        break;
      case "Tests":
        break;
      case "Allocation":
        break;
      case "Users":
        break;
    }
  };

  return (
    <Nav className={classes.sidebar}>
      <div>
        <Nav.Item>
          <Nav.Link
            as={NavLink}
            className={classes["sidebar-item"]}
            eventKey="assets"
            to="/assets"
            onClick={() => {
              handleOnClick("Assets");
            }}
          >
            <div className={classes.entry}>
              <img
                src={Toolbar1Logo}
                className={classes["sidebar-logo"]}
                alt="Sidebar 1 logo"
              />
              <div className={classes.spread}>
                <div className={classes["middle-text"]}>Assets</div>
                <ChevronRightIcon
                  style={{ fontSize: "20px", paddingTop: "4px" }}
                  className={classes["arrow-logo"]}
                />
              </div>
            </div>
          </Nav.Link>
        </Nav.Item>
        <Nav.Item>
          {/* <Nav.Link
          as={NavLink}
          className={classes["sidebar-item"]}
          eventKey="tests"
          to="/tests"
          onClick={() => {
            handleOnClick("Tests");
          }}
        > */}
          <div
            className={classes["sidebar-custom-item"]}
            onClick={() => {
              handleShowModal();
            }}
          >
            <div className={classes.entry}>
              <img
                src={Toolbar2Logo}
                className={classes["sidebar-logo"]}
                alt="Sidebar 2 logo"
              />
              <div className={classes.spread}>
                <div className={classes["middle-text"]}>Tests</div>
                <ChevronRightIcon
                  style={{ fontSize: "20px", paddingTop: "4px" }}
                  className={classes["arrow-logo"]}
                />
              </div>
            </div>
          </div>

          {/* </Nav.Link> */}
        </Nav.Item>
        <Nav.Item>
          <Nav.Link
            as={NavLink}
            className={classes["sidebar-item"]}
            eventKey="allocation"
            to="/allocation"
            onClick={() => {
              handleOnClick("Allocation");
            }}
          >
            <div className={classes.entry}>
              <img
                src={Toolbar3Logo}
                className={classes["sidebar-logo"]}
                alt="Sidebar 3 logo"
              />
              <div className={classes.spread}>
                <div className={classes["middle-text"]}>Allocation</div>
                <ChevronRightIcon
                  style={{ fontSize: "20px", paddingTop: "4px" }}
                  className={classes["arrow-logo"]}
                />
              </div>
            </div>
          </Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link
            as={NavLink}
            className={classes["sidebar-item"]}
            eventKey="users"
            to="/users"
            onClick={() => {
              handleOnClick("Users");
            }}
          >
            <div className={classes.entry}>
              <img
                src={Toolbar4Logo}
                className={classes["sidebar-logo"]}
                alt="Sidebar 4 logo"
              />
              <div className={classes.spread}>
                <div className={classes["middle-text"]}>Users</div>
                <ChevronRightIcon
                  style={{ fontSize: "20px", paddingTop: "4px" }}
                  className={classes["arrow-logo"]}
                />
              </div>
            </div>
          </Nav.Link>
        </Nav.Item>
      </div>
      {pathname.includes("allocation") ? (
        <div className={classes['radar-container']}
          onClick={() => handleShowRadar()}>
            <RadarChart isOpened={false}/>
        </div>
      ) : (
        <></>
      )}
      <RadarModal showRadar={showRadar} handleCloseRadar={handleCloseRadar}/>
      <TestModal showModal={showModal} handleCloseModal={handleCloseModal} />
    </Nav>
  );
};

export default Sidebar;
